import { request } from '@/shared/api/request'

export const getFaq = (id) => request({ url: `selftest/faq`, method: 'GET'})